import { useDiContainerInjection } from '@edikk-edikk/di-container';
import { Api } from '#src/react/api/Api';
import { DI_CONTAINER_TYPE } from '#srcJs/di-container';

const useApi = () => useDiContainerInjection<Api>(DI_CONTAINER_TYPE.api);

export { useApi };
